export default __webpack_public_path__ + "static/media/pdflayout1.5141e373.png";